import { render } from "./KpiGraph.vue?vue&type=template&id=6d6f0be8"
import script from "./KpiGraph.vue?vue&type=script&lang=js"
export * from "./KpiGraph.vue?vue&type=script&lang=js"

import "./KpiGraph.vue?vue&type=style&index=0&id=6d6f0be8&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__